import {
  deleteApiJingleCollectionsIdJingles,
  postApiJingleCollectionsIdJingles,
  postApiJingleCollectionsIdOrder,
} from '@/shared/api'
import { createMutation } from '@farfetched/core'

export const jingleRemoveFromCollection = createMutation({
  handler: deleteApiJingleCollectionsIdJingles,
})

export const jingleAddToCollection = createMutation({
  handler: postApiJingleCollectionsIdJingles,
})

export const jingleCollectionJinglesOrderUpdate = createMutation({
  handler: postApiJingleCollectionsIdOrder,
})
